'use client';

import { useAuth } from '~/components/providers/authentication/AuthProvider';
import { RoleInterface, User } from '~/payload-types';
import { checkRole } from '~/payload/authorization/checkRole';

import LexicalRenderer from '../LexicalRenderer';

type Props = RoleInterface & {};

const RoleBlock = (props: Props) => {
  const { loading, user } = useAuth();

  if (loading) {
    return null;
  }

  if (user == null) {
    return null;
  }

  if (
    props.checkType === 'role' &&
    props.role &&
    checkRole([props.role], user)
  ) {
    return <LexicalRenderer data={props.content} />;
  }

  if (
    props.checkType === 'users' &&
    props.users &&
    props.users.length > 0 &&
    props.users.map((u) => (u as User).id).includes(user.id)
  ) {
    return <LexicalRenderer data={props.content} />;
  }

  return null;
};

export default RoleBlock;
